/**
 * Region visibility/reassignment — shim over the shared package
 * (@eip/shared/types/regionAccess), the single source of truth for both
 * server and client. Display names stay here (UI copy, client-only).
 *
 * The wrappers keep the historical client contract of accepting plain
 * strings (AuthContext regions default to "" before load); the shared
 * helpers fall back to [region] / [] for unknown keys.
 */

import { Region, UserRole } from "@eip/shared/types";
import {
  getVisibleRegions as sharedGetVisibleRegions,
  getReassignableRegions as sharedGetReassignableRegions,
  getEffectiveVisibleRegions as sharedGetEffectiveVisibleRegions,
  canEditGlobalEmailTemplates as sharedCanEditGlobalEmailTemplates,
} from "@eip/shared/types/regionAccess";

export {
  REGION_VISIBILITY,
  REGION_REASSIGNMENT,
  ADMIN_LEVEL_ROLES,
  isAdminLevelRole,
  isSuperAdmin,
} from "@eip/shared/types/regionAccess";

export function getVisibleRegions(region: string): string[] {
  return sharedGetVisibleRegions(region as Region);
}

export function getReassignableRegions(region: string): string[] {
  return sharedGetReassignableRegions(region as Region);
}

export function getEffectiveVisibleRegions(role: string, region: string): string[] | null {
  return sharedGetEffectiveVisibleRegions(role as UserRole, region as Region);
}

export function canEditGlobalEmailTemplates(role: string, region: string): boolean {
  return sharedCanEditGlobalEmailTemplates(role as UserRole, region as Region);
}

export const REGION_DISPLAY_NAMES: Record<string, string> = {
  communitech:  "Communitech",
  northForge:   "North Forge",
  investOttawa: "Invest Ottawa",
  launchLab:    "Launch Lab",
  sparkCenter:  "Spark Centre",
};

export function getRegionDisplayName(region: string): string {
  return REGION_DISPLAY_NAMES[region] || region;
}
